// src/components/ReportAlertList/ReportAlertList.js
import React, { useMemo } from "react";
import "./style.css";

export default function ReportAlertList({ reportData }) {
  const { categories } = reportData;
  const pillars = categories.flatMap((cat) => cat.pillars);
  const attributes = pillars.flatMap((p) => p.attributes);

  const alertAttrs = useMemo(
    () => 
      attributes.filter(
        (attr, idx, arr) =>
          arr.findIndex(a => a.attribute_id === attr.attribute_id) === idx
      ).filter(
        attr => attr.grade_breakdown.some(gb => gb.grade === "D" && gb.number_of_respondents > 0)
      ),
    [attributes]
  );

  return (
    <div className="report-alert-list-container">
      <h2>Report Alerts</h2>
      <p className="report-alert-subtitle">
        These are areas in which one or more respondent scored low
      </p>

      {alertAttrs.length === 0 ? (
        <div className="report-alert-list">
          <div className="report-alert-item">
            <p className="report-alert-none">No alerts</p>
          </div>
        </div>
      ) : (
        <div className="report-alert-list">
          {alertAttrs.map(attr => (
            <div key={`${attr.attribute_id}`} className="report-alert-item">
              <div className="report-alert-attribute">
                {attr.attribute_name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
